var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.665 14.1075C12.398 14.1297 12.1533 13.9963 11.9086 13.8628C9.66162 12.5502 7.74838 10.6815 6.41356 8.45677C6.16884 8.07857 5.94637 7.63363 6.03536 7.18869C6.19109 6.3433 7.25895 6.0096 7.5704 5.20871C7.85961 4.51905 7.48141 3.7404 7.03648 3.13974C6.30232 2.13862 5.36795 1.27099 4.3001 0.625826C3.78842 0.314368 3.23224 0.0474043 2.63157 0.00291031C-0.0603131 -0.130572 -0.216042 4.36332 0.13991 6.12083C0.518109 7.94508 1.43024 9.63586 2.49809 11.1709C5.012 14.8194 8.46028 17.9117 12.6427 19.38C14.111 19.8917 15.6906 20.2032 17.2033 19.8472C17.9597 19.6692 18.6716 19.3355 19.2056 18.7571C19.7395 18.2009 20.0287 17.4001 19.8952 16.6437C19.7618 15.865 19.2278 15.2421 18.6939 14.6859C17.9153 13.885 17.0476 13.1731 16.1132 12.5502C15.9353 12.439 15.7573 12.3277 15.5571 12.3055C15.3346 12.2832 15.1344 12.3945 14.9342 12.5057C14.378 12.8172 13.8663 13.1954 13.4214 13.6181C13.2211 13.8183 12.9987 14.0185 12.7317 14.063C12.7095 14.0853 12.6872 14.1075 12.665 14.1075Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.13115f5b4e1de8c421ce8a4f2b92f67f.svg";
export { ForwardRef as ReactComponent };